<template>
  <div class="paper" id="printPaper">
    <div class="paper-bound" :style="'.visibleMode{ visibility: hidden }'">
      <div class="paper-head">
        <div class="logo">
          <img src="@/assets/paper_logo.jpg" width="110">
        </div>
        <div class="qrcode">
          <qrcode-vue :value="currentUrl" size="83" level="L" render-as="svg"></qrcode-vue>
        </div>
        <div class="id">
          문제지번호 : {{ this.$route.params.id }}
          <br>
          날짜 : {{ today }}
          <br>
          <el-button v-if="started" size="mini" type="primary" style="margin-top: 8px;z-index:99999" @click="submit()">답안제출하기</el-button>
        </div>
        <div class="title" style="text-align: left;width: 500px">
          <div class="top">
            <div class="grade">{{ this.grade }}학년 {{ this.semester }}학기</div>
          </div>
          <div class="chapter">{{ this.chapter }}</div>
          <div class="chapter2">{{ this.chapter2 }}
          </div>
        </div>
      </div>
      <div class="viewer" v-if="started">
        <div class="question" v-for="(my_rect, question_idx) in my_rects" :key="my_rect"
             :style="`width:${width}px;height:${height}px;margin-top:10px;`">
          <div id="app" style="position: absolute; text-align: left;">
            <span v-for="(rect, index) in my_rect.filter(rec => rec.type !== 'var')"
                      :key="index">
              <input class="filler" v-if="(rect.type === 'text' || rect.type === 'num') && (rect.answer && mode !== 1)"
                     :style="`z-index:999;border:0;text-align: right;font-size:${rect.size}px;font-weight:${rect.border};
                     width:${rect.width}px;height:${rect.height}px;left:${rect.left}px;top:${rect.top}px;position:absolute`" v-model="rect.userAnswer"/>
              <VueDragResize v-else
                             :w="rect.width"
                             :h="rect.height"
                             :x="rect.left"
                             :y="rect.top"
                             :parentW="listWidth"
                             :parentH="listHeight"
                             :axis="rect.axis"
                             :preventActiveBehavior="true"
                             :isActive="false"
                             :minw="rect.minw"
                             :minh="rect.minh"
                             :isDraggable="false"
                             :isResizable="false"
                             :parentLimitation="rect.parentLim"
                             :snapToGrid="rect.snapToGrid"
                             :aspectRatio="rect.aspectRatio"
                             :z="rect.zIndex"
                             v-on:dragging="changePosition($event, rect)"
                             v-on:resizing="changeSize($event, rect)">
                <div class="filler" v-if="(rect.type === 'text' || rect.type === 'num') && (!rect.answer || mode === 1)"
                     :style="(rect.type === 'num'?'color: #0000ee':';color: '+rect.foreColor)+';text-align: '+rect.alignment+';font-size:'+rect.size+'px;font-weight:'+rect.border+';border:'+rect.border_weight+'px solid ' + rect.border_color+(((!first_answer || question_idx !== 0) && rect.answer && mode === 0)?';display:none':(rect.answer?';color: #ff7f00 !important':''))">
                  <span>{{ rect.text }}</span>
                </div>
                <hr v-else-if="rect.type === 'line' && rect.direct === 'horizontal'"
                    :style="'position:absolute; display: inline-block;width:'+rect.size+`px;border-top: ${rect.thickness}px ${rect.style} ${rect.color};`">
                <div v-else-if="rect.type === 'line' && rect.direct === 'vertical'"
                     :style="'position:absolute; display: inline-block;height:'+rect.size+`px;border-left: ${rect.thickness}px ${rect.style} ${rect.color};`"></div>
              </VueDragResize>
            </span>
          </div>
        </div>
      </div>
      <div class="viewer" style="padding-top:70px;" v-else>
        <div class="description">{{ description }}</div>
        <div class="question after">
          <div id="app2" style="position: absolute;text-align:left;">
            <VueDragResize v-for="(rect, index) in my_rects[0].filter(rec => rec.type !== 'var')"
                           :key="index"
                           :w="rect.width"
                           :h="rect.height"
                           :x="rect.left"
                           :y="rect.top"
                           :parentW="listWidth"
                           :parentH="listHeight"
                           :axis="rect.axis"
                           :preventActiveBehavior="true"
                           :isActive="false"
                           :minw="rect.minw"
                           :minh="rect.minh"
                           :isDraggable="false"
                           :isResizable="false"
                           :parentLimitation="rect.parentLim"
                           :snapToGrid="rect.snapToGrid"
                           :aspectRatio="rect.aspectRatio"
                           :z="rect.zIndex"
                           v-on:dragging="changePosition($event, rect)"
                           v-on:resizing="changeSize($event, rect)">
              <div class="filler" v-if="rect.type === 'text'"
                   :style="(rect.type === 'num'?'color: #0000ee':';color: '+rect.foreColor)+';text-align: '+rect.alignment+';font-size:'+rect.size+'px;font-weight:'+rect.border+';border:'+rect.border_weight+'px solid ' + rect.border_color+(rect.answer?';color:#FF8C00':'')">
                <span>{{ rect.text }}</span>
              </div>
              <hr v-else-if="rect.type === 'line' && rect.direct === 'horizontal'"
                  :style="'position:absolute; display: inline-block;width:'+rect.size+`px;border-top: ${rect.thickness}px ${rect.style} ${rect.color};`">
              <div v-else-if="rect.type === 'line' && rect.direct === 'vertical'"
                   :style="'position:absolute; display: inline-block;height:'+rect.size+`px;border-left: ${rect.thickness}px ${rect.style} ${rect.color};`"></div>
            </VueDragResize>
          </div>
        </div>
        <br/>
        <el-button type="primary" icon="el-icon-edit" size="medium" @click="startCheck()"
                   :style='`margin-top: ${height+70}px;margin-left: 360px`'>시작하기
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import QrcodeVue from 'qrcode.vue';

const moment = require('moment')
import VueDragResize from 'vue-drag-resize'

export default {
  name: "TesterViewer",
  components: {
    QrcodeVue, VueDragResize
  },
  data() {
    return {
      started: false,
      controller: {
        template: null
      },
      description: '',
      first_answer: false,
      show_answer: false,
      semester: '',
      grade: '',
      chapter: '',
      chapter2: '',
      badge: '',
      width: 0,
      height: 0,
      visibleMode: true,
      currentUrl: '',
      my_rects: [],
      today: '',
      questionDataId: 0,
      inform: {}
    }
  },
  created() {
    if (this.$route.query.started === '1')
      this.started = true
  },
  mounted() {
    this.today = moment().format('YYYY-MM-DD')
    this.fetchData();
  },
  methods: {
    submit() {
      console.log(this.inform, this.questionDataId, this.my_rects)
      this.$http.post('/api/score/submit', {
        inform: this.inform,
        chapter_id: this.questionDataId,
        rects: this.my_rects
      }).then((result) => {
          console.log(result)
          this.$router.push('/score_edit');
        })
        .catch(() => {
          alert("제출에 오류가 발생했습니다.")
        })
    },
    fetchData() {
      this.currentUrl = window.location.href;
      this.$http.get(`/api/problem/${this.$route.params.id}`)
          .then((result) => {
            console.log(result.data.vars)
            this.questionDataId = result.data.vars.questionDataId
            let inform = result.data.inform
            this.my_rects = JSON.parse(result.data.vars.vars);
            for (let x of this.my_rects) {
              for (let y of x) {
                if (y.type === 'text' && y.answer) y['userAnswer'] = ''
              }
            }
            console.log(this.my_rects)
            this.grade = inform['grade'];
            this.semester = inform['semester'];
            this.width = inform['width'];
            this.height = inform['height'];
            this.chapter = inform['name'];
            this.chapter2 = inform['questionName'];
            console.log(inform)
            this.first_answer = inform['first_answer'];
            this.description = inform['description'];
            this.badge = inform['badge'];
            this.inform = inform
          })
    },
    startCheck() {
      if (this.token === null || this.token === '') {
        alert("로그인이 필요합니다");
      } else {
        this.started = true
      }
    },
    printProblem() {
// Get HTML to print from element
      const prtHtml = document.getElementById('printPaper').innerHTML;

// Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

// Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=877,height=1102,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      /*
      printJS({
          printable: "printPaper",
          type: "html",
          onPrintDialogClose: () => console.log("The print dialog was closed"),
          onError: e => console.log(e)
      });

       */
      //this.$store.commit("setPrintState", {printState: 0})
    }
  },
  watch: {
    '$route': 'fetchData',
    'mode': 'fetchData',
    'printState': "printProblem"
  },
  computed: mapGetters({
    token: "getToken",
    username: "getUsername",
    inform: "getState",
    mode: "getMode",
    printState: "getPrintState"
  })
}
</script>

<style>
.description {
  max-width: 820px;
  font-size: 25px;
  text-align: left;
}

.viewer {
  padding: 20px 30px 20px 30px;
  text-align: left;
}

.question {
  display: inline-block;
}

.paper {
  max-width: 874px;
  min-height: 1123px;
  box-sizing: border-box;
}

.paper-bound {
  border: 3px solid #dddddd;
  width: 871px;
  height: 290mm;
  position: relative;
  float: top;
}

.paper-head {
  height: 92px;
  overflow: hidden;
  border: 1px solid #333333;
}

.after::after {
  clear: both
}

.paper-head .logo {
  width: 128px;
  height: 92px;
  float: left;
  color: black;
  background-color: white;
  border-right: 1px solid #333333;
  text-align: center;
}

.paper-head .title {
  margin: 0px 92px 0px 130px;
  height: 92px;
  padding: 0px 0px 0px 5px;
  position: relative;
  white-space: nowrap;
}

.paper-head .qrcode {
  float: right;
  border-left: 1px solid #333;
  width: 83px;
  height: 83px;
  padding: 6px;
}

.id {
  float: right;
  position: relative;
  text-align: right;
  font-size: 10pt;
  font-weight: normal !important;
  padding-top: 10px;
  margin-right: 10px;
}

.title {
  font-family: "나눔스퀘어라운드";
}

.title div.grade {
  font-size: 15px;
  line-height: 26px;
  width: 130px;
  font-family: inherit;
  margin: 5px;
}

.title div.chapter {
  font-size: 24px;
  line-height: 26px;
  font-family: inherit;
}

.title div.chapter2 {
  font-size: 17px;
  line-height: 26px;
  font-family: inherit;
}

.title div.chapter2 small {
  font-size: 12px;
  font-family: inherit;
}

.badge {
  padding: 2px 14px 3px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: bold;
  line-height: 14px;
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  white-space: nowrap;
  vertical-align: baseline;
  background-color: #999;
  margin-left: 5px;
}

.logo > img {
  position: relative;
  top: 23px;
  margin: auto auto;
}
</style>